<template>
    <div>
        <card-header title='New Conference' icon="fa-plus" />

        <card-body>
            <conference-form :conference="conference" />
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!conference.content_provider_id || !conference.title || !conference.code || !conference.start || !conference.end"
                    ><i class="fas fa-plus mr-2"></i>New Conference
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";

    import CourseForm from "@/cards/courses/CourseForm";
    import ConferenceForm from "@/cards/conferences/ConferenceForm";

    import {client as http} from "@/http_client";
    import {mapGetters} from "vuex";

    export default {
        components: {ConferenceForm, CardHeader, CardToolbar, CardBody, CardFooter, CourseForm},
        props: ['card'],
        data() {
            return {
                conference: {
                    is_allow_cc: 1,
                    is_allow_po: 0,
                    is_allow_invoice: 0,
                    contentProviders: null,
                    content_provider_id: null
                }
            }
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {
            load: function() {
                if (this.currentUser.isSuper || !this.currentUser.isContentProvider) {
                    http.get('content-providers', {force: true}).then(response => {
                        this.conference.contentProviders = response.data;
                        this.$emit('loading', false);
                    }).catch(err => {
                        console.log(err);
                        this.$emit('loading', false);
                    });
                } else {
                    this.conference.content_provider_id = this.currentUser.contentProviderId;
                    this.$emit('loading', false);
                }
            },
            submit: function () {
                this.$emit('loading', true);
                let payload = {...this.conference,};
                delete payload.contentProviders;
                http.post('conferences', payload, {force: true}).then(response => {
                    this.$reloadCard('conferences');
                    this.$closeCard(this.card);
                }).catch(err => {
                    if (err.response.status === 400) {
                        window.alert('Conference code must be unique. There is already a conference using that code.  Please choose a different once.');
                    } else {
                        window.alert('An error occurred while saving the conference.');
                    }
                    this.$emit('loading', false);
                });
            }
        },
        mounted() {
            this.load();
        }
    }
</script>
